<kendo-card width="auto" class="general-card new-form-card">
  <form id="thisform" class="general-form" [formGroup]="$formGroup()" (ngSubmit)="onSubmit()">
    <kendo-card-body id="new-card-body">
      <kendo-stacklayout orientation="vertical" [gap]="rowGap">
        <ng-content>
          <!-- form elements go here -->
        </ng-content>
      </kendo-stacklayout>
    </kendo-card-body>
    <kendo-card-footer>
      <kendo-stacklayout id="new-card-footer" orientation="horizontal">
        <kendo-stacklayout [align]="{ horizontal: 'end' }" [gap]="5">
          <ng-content select="[submit-options]" />
          @if ($showSubmit()) {
            <button kendoButton type="submit" themeColor="secondary" [disabled]="$formLoading()" [svgIcon]="submitIcon">
              @if ($formLoading()) {
                <kendo-loader size="small" />
              }
              {{ $actionName() }}
            </button>
          }
        </kendo-stacklayout>
      </kendo-stacklayout>
    </kendo-card-footer>
  </form>
</kendo-card>
